import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { TranslocoModule } from '@jsverse/transloco';

import { CapitalizePipe, FloatDirective } from '@hmax-order/frontend/utils';
import { ValidateFieldsService } from '../validate-fields.service';

@Component({
  selector: 'hmax-input-number',
  standalone: true,
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  imports: [
    CommonModule,
    CapitalizePipe,
    FloatDirective,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslocoModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
})
export class InputNumberComponent {
  label = input<string>();
  hiddenLabel = input<boolean>();
  translate = input<boolean>(true);
  placeholder = input<string>();
  classInput = input<string>();
  icon = input<string>();
  iconText = input<string>();
  iconSize = input<string>();
  min = input<number>();
  max = input<number>();
  step = input<number>();
  formGroup = input<FormGroup>();
  controlName = input<string>();
  autocomplete = input<string>('');
  isFloat = input<boolean>(false);
  decimalQty = input<number>(2);
  emitEvent = input<boolean>(false);
  appearance = input<'outline' | 'fill'>('outline');
  readonly = input<boolean>();
  /** Define se o componente deve reagir a teclas numéricas, Enter e Espaço */
  keyboardActive = input<boolean>();
  allowNegative = input<boolean>(false);

  clickEvent = output<void>();
  keyboardEvent = output<string>();
  blurEvent = output<void>();

  validateField = inject(ValidateFieldsService);

  resolvedControlName = computed(() => this.controlName() ?? this.label());

  get formControl(): AbstractControl {
    return this.formGroup()?.controls[this.resolvedControlName() as string] as AbstractControl;
  }

  triggerClickEvent(): void {
    this.clickEvent.emit();
  }

  triggerBlurEvent(): void {
    this.blurEvent.emit();
  }

  /**
   * Emite o botão pressionado pelo usuário
   */
  handleKeyDown(event: KeyboardEvent): void {
    if (!this.keyboardActive()) {
      return;
    }

    const { key } = event;

    if (key === '-' && !this.allowNegative()) {
      event.preventDefault();
      return;
    }

    const isActionKey = key === 'Enter' || key === ' ';
    // Evita rolagem ao pressionar espaço
    if (isActionKey) {
      event.preventDefault();
    }

    this.keyboardEvent.emit(key);
  }
}
